import './scss/style.scss';
import Title from './routes/title';
import Knowledge from './routes/knowledge';
import Questions from './routes/questions';
import Answers from './routes/answers';
import Header from './components/header';
import Topbar from './components/topbar';
import {useEffect, useState} from 'react'
import Footer from './components/footer';
import {useLayoutContext} from './context/game';
import { useLightboxContext } from './context/lightbox';
import Lightbox from './components/lightbox';
function App() {
  const url_route = new URLSearchParams(window.location.search).get('route') || window.route;
  const global_data = window.global_data;
  const game_data = window.game_data;
  const [route,setRoute] = useState(url_route || 'title');
  const [El,setEl] = useState(<Title  title={global_data?.wheel?.title} description={global_data?.wheel?.description} optionCount={game_data?.length}/>);
  const [_,setContext] = useLayoutContext();
  const routeEvent = (route) => new CustomEvent('route:change',{detail:{route}});
  const qCount = Object.keys(game_data?.questions || {}).length;
  const [lightboxImage] = useLightboxContext();
  useEffect(()=>{
    switch(route){
      case('knowledge'):
        setEl(<Knowledge content={global_data?.knowledge?.content || ''} setRoute={setRoute}/>)
      break;
      case('questions'):
        setEl(<Questions count={qCount} setRoute={setRoute}/>)
      break;
      case('answers'):
        setEl(<Answers setRoute={setRoute}/>)
      break;
      default:
        setEl(<Title title={global_data?.wheel?.title} description={global_data?.wheel?.description} optionCount={qCount} setRoute={setRoute}/>)
      break

    }
    setContext({route})
    document.body.dispatchEvent(routeEvent(route));
  },[route])
  
  return (
    <>
      <Header title={global_data?.top?.title} subtitle={global_data?.top?.subtitle}/>
      <Topbar title={global_data?.topbar?.title} count={qCount} />
      <div className="flex-grow-1 d-flex flex-column">
        {El}
      </div>
      <Footer />
      <Lightbox image={lightboxImage}/>
    </>
  );
}

export default App;
